import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";

export const assignmentPeriodLoader: LoaderFunction = async (args) => {
    if (args.params.assignmentPeriodCode === "new") {
        return new Promise((res) => res(Result.newResult()))
    }
    const result = await axiosApi.get("/api/assignmentPeriods/" + args.params.assignmentPeriodCode);
    return result.data
}